import { AppContext } from 'commons-ui';
import { useContext } from 'react';

export const makeActionHandler = (action: any, params: any) => {
	const { history, rowData, versionSupportedConfig, setConfirmationDialog, removeLayout } = params;
	const { showAlert } = useContext(AppContext);

	switch (action.id) {
		case 'edit':
			return () => {
				history.push({
					pathname: '/dashboard/homepagelayout/layout/edit',
					state: {
						rowData,
						parentRowData: versionSupportedConfig
					}
				});
			};

		case 'add':
			return () => {
				history.push({
					pathname: '/dashboard/homepagelayout/layout/create',
					state: {
						rowData: versionSupportedConfig
					}
				});
			};

		case 'back':
			return () => {
				history.push({
					pathname: '/dashboard/homepagelayout/list'
				});
			};

		case 'remove': {
			const remove = () => {
				return removeLayout(versionSupportedConfig, rowData, showAlert);
			};

			return () => {
				setConfirmationDialog({
					show: true,
					header: 'Remove from app?',
					handleAlertConfirmation: remove
				});
			};
		}
		default:
			return () => {};
	}
};

export default {
	makeActionHandler
};
